export const Dashboard = () => {
  
    return (
        <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
            <div className={`w-full bg-white border rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>

                <div className="flex items-center">

                    <div className="flex items-center gap-2.5">

                Dashboard

                    </div>
                </div>
               
            </div>
        </div>
    )
}